import { useEffect, useState } from "react"
import { Navigate, useLocation } from "react-router-dom"
import useLoginWithGoogle from "@/modules/auth/queries/use-login-with-google"
import mixpanelClient from "@/services/mixpanel"

export default function GoogleAuth() {
  const location = useLocation()
  const [error, setError] = useState(false)
  const loginWithGoogle = useLoginWithGoogle()

  useEffect(() => {
    auth()
  }, [])

  async function auth() {
    const queryParams = new URLSearchParams(location.search)
    const code = queryParams.get("code") ?? ""
    try {
      await loginWithGoogle.mutateAsync(code)
    } catch {
      setError(true)
    }
  }

  if (error || loginWithGoogle.isError) {
    return <Navigate to="/login" />
  }

  if (loginWithGoogle.isSuccess && !loginWithGoogle.data.data.user.wasOnboarded) {
    return <Navigate to="/onboarding" replace />
  }

  if (loginWithGoogle.isSuccess) {
    mixpanelClient.login.completed({
      userId: loginWithGoogle.data.data.user.id,
      name: loginWithGoogle.data.data.user.name,
      email: loginWithGoogle.data.data.user.email,
      lastLogin: new Date().toISOString(),
    })
    return <Navigate to="/dashboard" />
  }

  return null
}
